import $ from 'jquery';
import 'slick-carousel';

const sliders = [
	{
		class: '.masthead-slider__wrapper > .slides, .wp-block-carousel.is-style-singular .content',
		args: {
			adaptiveHeight: false,
			centerMode: true,
			slidesToShow: 1,
			centerPadding: 0,
		},
	},
	{
		class: '.em-featured-solutions__content-container',
		args: {
			adaptiveHeight: false,
			slidesToShow: 2,
			infinite: false,
			dots: true,
			responsive: [
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		},
	},
	{
		class: ".wp-block-carousel:not('.is-style-singular') .content",
		args: {
			adaptiveHeight: false,
			slidesToShow: 2,
			responsive: [
				{
					breakpoint: 850,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		},
	},
	{
		class: '.em-related-products__content',
		args: {
			adaptiveHeight: true,
			dots: true,
			slidesToShow: 4,
			infinite: false,
			responsive: [
				{
					breakpoint: 600,
					dots: false,
					settings: {
						slidesToShow: 1,
					},
				},
				{
					breakpoint: 760,
					dots: true,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 960,
					dots: true,
					settings: {
						slidesToShow: 3,
					},
				},
			],
		},
	},
	{
		class: '.em-resource-posts-slider__content',
		args: {},
	},
];

export default class BlockSlickSlider {
	constructor(slider, customArgs) {
		this.slider = $(slider);
		this.args = {
			adaptiveHeight: true,
			arrows: true,
			fade: true,
			infinite: false,
			slidesToShow: 1,
		};

		if (Object.values(customArgs).length) {
			this.args = customArgs;
		}

		this.initialize();
	}

	initialize() {
		if (this.slider.length) {
			this.slider.slick(this.args);
		}
	}
}

const blockSlider = {
	init() {
		sliders.map((slider) => new BlockSlickSlider(slider.class, slider.args));
	},
};

blockSlider.init();
